import { factory } from "../../../../utils/apiThunkFactory";
import { debouncer } from "../../../../utils/debouncer";

export const getRoomConfig = factory.get('livekit/getToken', '/api/token/room-config');
export const getTestToken = factory.get('livekit/getTestToken', '/api/token/test');

export const createDebouncedGetRoomConfig = (dispatch) => {
    // Thunk expects single object argument
  return () => {
    debouncer.debounce('get-livekit-token', () => {
      dispatch(getRoomConfig());
    }, 400);
  };
};